import React, { useEffect, useState } from "react";
import { MdDashboard } from "react-icons/md";
import { useLocation } from "react-router-dom";

export default function Route({
  name = "Route name",
  icon = <MdDashboard />,
  onClick = null,
  urlPath = "",
  isCollapsed = false,
}) {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const currentPath = location.pathname.split("/")[2];
    setIsActive(urlPath === currentPath);
  }, [location.pathname, urlPath]);

  return (
    <div
      onClick={onClick}
      className={`
        group flex items-center gap-3 mb-1 cursor-pointer rounded-lg transition-all duration-200
        ${isCollapsed ? 'justify-center px-3 py-3' : 'px-4 py-3'}
        ${
          isActive
            ? "bg-blue-600 text-white shadow-md shadow-blue-900/20"
            : "text-slate-400 hover:bg-slate-800 hover:text-white"
        }
      `}
      title={isCollapsed ? name : ""}
    >
      <div className={`text-xl ${isActive ? "text-white" : "text-slate-400 group-hover:text-white transition-colors"}`}>
        {icon}
      </div>
      {!isCollapsed && (
        <div className="font-medium text-sm tracking-wide">
          {name}
        </div>
      )}
    </div>
  );
}
